<template>
    <div v-loading.fullscreen.lock="loading">
        <travel-search-bar-component  
            :AllAddress="AllAddress"         
            add_auth="新增差旅申请"
            @search="get_travel_index"
            @addTeam="addTeam"
        ></travel-search-bar-component>
        <common-table-component
            details_auth="差旅申请详情"
            :col_arr="fcol_arr"
            :table_data="ftable_data"
            @details_row="details_travel"
            table_height="549px"
        ></common-table-component>
        <common-page-component
            :current_page="cond.page"
            :page_size="cond.limit"
            :total="ftotal"
            @search="get_travel_index"
        ></common-page-component>
        <travel-edit-component
            :AllClient="AllClient"
            :AllAddress="AllAddress"
            :id="fid"
            :show_type="edit_type"
            :dialogFormVisible="fdialogFormVisible"
            :travel_details_data="travel_details_data"
            :enterprise_department="enterprise_department"
            :edit_auth="edit_auth"
            :del_auth="del_auth"
            :add_file_auth="add_file_auth"
            :to_approval_auth="to_approval_auth"
            :sel_approval_auth="sel_approval_auth"
            :ApprovalAuth="ApprovalAuth"
            :withdraw_auth="withdraw_auth"
            print_auth="打印差旅申请"
            :budget_count="budget_count"
            @show_edit="show_edit"
            @addTeam="addTeam"
            @search="get_travel_index"
            @exitTravelDialog="dialogExit"
            @frefresh="frefresh"
            @details_row="details_travel"
        ></travel-edit-component>
    </div>
</template>

<script>
import { enterprise_department_request} from '@/network/enterprise.js'
import { travel_index_request,travel_details_request} from '@/network/finance/travel.js'
import { thousandBitSeparator,fomatFloat} from '@/assets/js/common.js'
import { entertain_client_list_request,travel_address_list_request} from '@/network/list.js'
import { budget_count_request } from '@/network/finance/BudgetUse.js'


import TravelSearchBarComponent from '@/components/finance/travel/TravelSearchBarComponent'
import CommonTableComponent from '@/components/common/CommonTableComponent'
import CommonPageComponent from '@/components/common/CommonPageComponent'
import TravelEditComponent from '@/components/finance/travel/TravelEditComponent'

export default {
    name:'',
    data(){
        return {
            fid: 0,
            edit_type: 0,
            loading: false,
            fdialogFormVisible: false,
            cond: {
                name: '',
                state: '',
                contain_entertain: '',
                use_state: '',
                enterprise_id: '',
                department_id: '',
                staff_id: '',
                client_id:'',
                address_id: '',
                title_content: '',
                page: 1,
                limit: 10,
            },
            AllClient:[],
            AllAddress:[],
            ftotal: 0,
            ftable_data: [],
            fcol_arr: [
                {
                    prop: 'start_date',
                    label: '出差日期',
                    minWidth: '100px',
                },
                {
                    prop: 'name',
                    label: '差旅单号',
                    minWidth: '120px'
                },
                {
                    prop: 'state',
                    label: '审批状态',
                    minWidth: '100px',
                    tag: (d) => {
                        if(d===0) {
                            return {
                                type: 'info',
                                filter_data: '待提交'
                            }
                        } else if(d===1) {
                            return {
                                type: '',
                                filter_data: '审批中'
                            }
                        } else if(d===2) {
                            return {
                                type: 'success',
                                filter_data: '已通过'
                            }
                        } else if(d===3) {
                            return {
                                type: 'danger',
                                filter_data: '已驳回'
                            }
                        }
                    }
                },
                {
                    prop: 'use_state',
                    label: '使用情况',
                    minWidth: '100px',
                    tag: (d) => {
                        if(d===0) {
                            return {
                                type: 'info',
                                filter_data: '未使用'
                            }
                        } else if(d===1) {
                            return {
                                type: 'success',
                                filter_data: '已使用'
                            }
                        }
                    }
                },
                {
                    prop: 'title',
                    label: '差旅标题',
                    minWidth: '300px',
                    show_overflow_tooltip: true
                },
                {
                    prop: 'address_name',
                    label: '差旅地址',
                    minWidth: '300px',
                    show_overflow_tooltip: true
                },
                {
                    prop: 'days',
                    label: '出差天数',
                    minWidth: '120px'
                },
                {
                    prop: 'money',
                    label: '申请金额(元)',
                    minWidth: '120px',
                    editdata(row) {
                        return thousandBitSeparator(fomatFloat(row['money']))
                    }
                },
                {
                    prop: 'current_examine_staff_name',
                    label: '当前审批人',
                    minWidth: '100px',
                },
                {
                    prop: 'staff_name',
                    label: '申请人',
                    minWidth: '100px',
                },
                {
                    prop: 'department_name',
                    label: '申请部门',
                    minWidth: '120px'
                },
                {
                    prop: 'enterprise_name',
                    label: '申请企业',
                    minWidth: '260px'
                }
            ],
            travel_details_data: {},
            enterprise_department: [],
            edit_auth: false,
            del_auth: false,
            //补充附件
            add_file_auth: false,
            //提交
            to_approval_auth: false,
            //查看审批
            sel_approval_auth: false,
            //审批
            ApprovalAuth: false,
            //撤回审批
            withdraw_auth: false,
            budget_count: {
                all_quota: 0,
                use_quota: 0,
                per_quota: 0,
                entertain_quota: 0,
                travel_quota: 0,
                other_quota: 0
            }
        }
    },
    computed:{},
    methods:{
        get_travel_index(param = {}) {
            this.loading = true
            this.cond.name = param.name ?? this.cond.name
            this.cond.state = param.state ?? this.cond.state
            this.cond.contain_entertain = param.contain_entertain ?? this.cond.contain_entertain
            this.cond.use_state = param.use_state ?? this.cond.use_state
            this.cond.enterprise_id = param.enterprise_id ?? this.cond.enterprise_id            
            this.cond.address_id = param.address_id ?? this.cond.address_id
            this.cond.client_id = param.client_id ?? this.cond.client_id
            this.cond.department_id = param.department_id ?? this.cond.department_id
            this.cond.staff_id = param.staff_id ?? this.cond.staff_id
            this.cond.title_content = param.title_content ?? this.cond.title_content
            this.cond.page = param.page ?? this.cond.page
            if (param.limit) {
                this.cond.limit = param.limit
                this.cond.page = 1
            }

            travel_index_request(this.cond)
                .then((s) => {
                    this.loading = false
                    if (s.status === 0) {
                        this.ftable_data = s.result.data
                        this.ftotal = s.result.total
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.loading = false
                    this.$message.error(err)
                })
        },
        details_travel(id) {
            this.fid = id
            this.fdialogFormVisible = true
            travel_details_request(id)
                .then((s) => {
                    if (s.status === 0) {
                        this.travel_details_data = s.result
                        this.travel_details_data.department_id = [s.result.enterprise_id,s.result.department_id]
                        //权限判断
                        this.is_auth(s.result)
                        //获取预算
                        const department_id = this.travel_details_data.department_id[1]
                        const year = this.travel_details_data.start_time ? this.travel_details_data.start_time.substr(0,4) : 0
                        this.get_budget_count(department_id ,year)
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        addTeam() {
            this.edit_type = 1
            this.fdialogFormVisible = true
            this.budget_count ={
                all_quota: 0,
                use_quota: 0,
                per_quota: 0,
                entertain_quota: 0,
                travel_quota: 0,
                other_quota: 0
            }
        },
        show_edit() {
            this.edit_type = 2
            this.budget_count ={
                all_quota: 0,
                use_quota: 0,
                per_quota: 0,
                entertain_quota: 0,
                travel_quota: 0,
                other_quota: 0
            }
        },
        dialogExit() {
            this.fdialogFormVisible = false
            this.fid = 0
            this.edit_type = 0
            this.budget_count ={
                all_quota: 0,
                use_quota: 0,
                per_quota: 0,
                entertain_quota: 0,
                travel_quota: 0,
                other_quota: 0
            }
        },
        get_enterprise_department() {
            this.loading = true
            enterprise_department_request()
                .then((s) => {
                    this.loading = false
                    if (s.status === 0) {
                        this.enterprise_department = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.loading = false
                    this.$message.error(err)
                })
        },
        frefresh() {
            this.details_travel(this.fid)
            this.get_travel_index()
        },
        is_auth(res) {
            this.edit_auth = false
            this.del_auth = false
            this.add_file_auth = false
            this.to_approval_auth = false
            this.sel_approval_auth = false
            this.ApprovalAuth = false
            this.withdraw_auth = false
            
            if(res.state === 0) {
                //判断创建人或申请人是否为自己
                if((res.staff_id === this.$store.state.user.id) || (res.create_staff === this.$store.state.user.id)) {
                    this.to_approval_auth = this.$_has('提交差旅申请')
                    this.edit_auth = this.$_has('修改差旅申请')
                    this.del_auth = this.$_has('删除差旅申请')
                }
            } else if(res.state === 1) {
                 //判断创建人或申请人是否为自己
                if((res.staff_id === this.$store.state.user.id) || (res.create_staff === this.$store.state.user.id)) {
                    this.add_file_auth = this.$_has('补充差旅申请附件')
                    this.withdraw_auth = this.$_has('撤回差旅申请')
                }
                //判断当前审批人是否为自己
                if(res.current_examine_staff_id === this.$store.state.user.id) {
                    this.ApprovalAuth = this.$_has('审批差旅申请')
                }
                this.sel_approval_auth = this.$_has('查看差旅申请审批记录')
            } else if(res.state === 2) {
                if((res.staff_id === this.$store.state.user.id) || (res.create_staff === this.$store.state.user.id)) {
                    this.add_file_auth = this.$_has('补充差旅申请附件')
                }
                this.sel_approval_auth = this.$_has('查看差旅申请审批记录')
            } else if(res.state === 3) {
                //判断创建人或申请人是否为自己
                if((res.staff_id === this.$store.state.user.id) || (res.create_staff === this.$store.state.user.id)) {
                    this.to_approval_auth = this.$_has('提交差旅申请')
                    this.edit_auth = this.$_has('修改差旅申请')
                    this.del_auth = this.$_has('删除差旅申请')
                }
                this.sel_approval_auth = this.$_has('查看差旅申请审批记录')
            }
        },
        get_all_entertain_client() {
            entertain_client_list_request()
                .then((s) => {
                    if (s.status === 0) {
                        this.AllClient = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.$message.error(err)
                })
        },
        get_all_travel_address() {
            travel_address_list_request()
                .then((s) => {
                    if (s.status === 0) {
                        this.AllAddress = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.$message.error(err)
                })
        },
        get_budget_count(department_id,year) {
            budget_count_request({ department_id:department_id, year:year })
                .then((s) => {
                    this.budget_count = s.result
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    },
    filters:{},
    props:{},
    created(){
        this.get_enterprise_department()
        this.get_all_entertain_client()
        this.get_all_travel_address()
        this.get_travel_index()
    },
    destoryed(){},
    mounted(){},
    updated(){},
    components:{
        TravelSearchBarComponent,
        CommonTableComponent,
        CommonPageComponent,
        TravelEditComponent
    },
    watch:{}
}
</script>

<style lang='less'></style>